import React, { Component } from 'react';
import $ from 'jquery';
import Script from 'react-load-script';
import { BrowserRouter as Router, Switch, Route, Link, browserHistory } from 'react-router-dom';
import Helmet from 'react-helmet';

class Director extends Component {

	render() {
    return (
        <div>
        <Helmet
                title="Directors | RAT Films | Commercials Filim Makers"
                meta={[
                  { name: 'description', content: "Meet the talented directors of Rat films, Ruchi Narain, Ashutosh Shah and Taher Mithaiwala." },
                  

                  ]}
              />
        <section className="page-section director " >
          <div className="container ">
            <div className="slider-section img-section" >
              <img src={require('../img/ruchinarain_th4bw.png')}  alt=""/>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <h3 className="heading">DIRECTORS</h3>
                <h3 className="subheading">RUCHI NARAIN</h3>
              </div>
              <div className="col-sm-8 cntnt-half ">
                <p className="heading two">RAT Films</p>
                <p>Ruchi Narain is a Multi Award winning Writer, Director, and Producer. She won the Filmfare award for writing Hazaaron Khwahishein Aisi and then made KAL (Yesterday & Tomorrow) which won the Osian’s Cinefan Critic’s Choice Award. Since then she has been directing commercials, of which many have been clutter breakers and boosted the brand sales exponentially (Kellogg’s All Bran and Kellogg’s Choco's), as well as a successful multi-starer campaign for the National Literacy Mission. She has directed a vast range of commercials from Beauty to Kids to Electronics.</p>
                <p>She is currently writing and directing Hanuman Da Damdaar, an animation feature produced by Percept as well as an untitled film for Dharma Productions. She is adapting an American TV series for its official Indian remake for Life OK and is the Creative Producer.</p>
                <p>Wanting to promote new talent, Ruchi started producing for younger directors as well. She has produced award winning wildlife documentaries which were shown on Discovery Channel as well as shorts, music videos and commercials. A docu-feature for an NGO is also under production.</p>
              </div>
              
              
            </div>
          </div>
        </section>

        <section className="page-section director ">
          <div className="container dtd-tp-brdr">
            <div className="slider-section img-section" >
              <img src={require('../img/ashutoshtaher_th5.png')}  alt=""/>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <h3 className="heading">DIRECTORS</h3>
                <h3 className="subheading">ASHUTOSH SHAH &<br /> TAHER MITHAIWALA</h3>
              </div>
              <div className="col-sm-8 cntnt-half ">
                <p className="heading two">RAT Films</p>
                <p>Ashutosh Shah and Taher Mithaiwala are brothers bound by… not Fevikol, but their vision and passion for film-making. They came together for a college documentary on Naxalism for which they won many film fests. It was on seeing this film that they were instantly offered jobs by acclaimed filmmakers Madhur Bhandarkar and Sudhir Mishra. This marked their entry into Bollywood and their partnership.</p>
                <p>They went on to do Three feature films with Sudhir Mishra as his Associate Directors and 2nd Unit directors.  From critical success they went on to work (as 1st Ads) in films which met with huge commercially success; Once Upon a Time in Mumbai by Milan Luthria and Balaji films and Karan Johar’s magnum opus Agneepath.</p>
                <p>In between they honed their skills by working on over 135 commercials with the likes of Prakash Varma, Uzer khan, Amit sharma, Vinil Mathew, Farouk Al Joffrey and a lot of international ad film directors. The result is that they have worked with some of the best most creative minds in advertising and the most talented and efficient crews in the business.</p>
                <p>True to their track record, the boys have now become directors with a bang! Their first project, a public service music video for adult literacy called Shiksha ka Suraj has been received with accolades and was trending on YouTube in the first weekend of its launch. It stars Shah Rukh Khan, Kareena Kapoor, Priyanka Chopra, Anil Kapoor, Farhan Akhtar and Shabana Azmi and has been hailed by the press as ‘the Mile Sur of this Millennium’!</p>
                <p>Having shot the video in a very ‘real and rustic’ space, they went on to direct the The Skoda Prize Film for its Indian Contemporary Art Prize 2012, featuring finalists Jitesh Kallat, LN Tallur and winner Navin Thomas. This is a visual, artistic extravaganza, with stunning shots and cutting edge contemporary style.</p>
              </div>
              
              
            </div>
          </div>
        </section>
		
        </div>

		
    );
  }
}

export default Director;


// WEBPACK FOOTER //
// ./src/components/directors.js